import type { Module } from 'vuex'
import type { RootState } from '@/store'
import type { DeveloperPanelState } from './types'
import { DEVELOPER_PANEL_ACTIONS, DEVELOPER_PANEL_GETTERS } from './types'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state from './state'

const developerPanel: Module<DeveloperPanelState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}

export { DEVELOPER_PANEL_ACTIONS, DEVELOPER_PANEL_GETTERS }
export type { DeveloperPanelState }
export default developerPanel
